import { useContext, useEffect, useState } from 'react';

import { Formik } from 'formik';
import { useNavigate, useParams } from 'react-router-dom';
import * as Yup from 'yup';

import { EventContext } from '../../Contexts/EventContext';
import ErrorMessage from '../../Shared/Components/ErrorMessage';
import Loading from '../../Shared/Components/Loading';
import { error, success } from '../../Shared/Components/Toast';
import useApi from '../../Shared/hooks/api/Index';
/** @format */
import Master from '../Layouts/Master';

const validationSchema = Yup.object().shape({
  name: Yup.string()
    .required('نام استان الزامی است')
    .max(190, 'نام استان نمیتواند بیشتر از 190 کاراکتر باشد'),
});

const EditProvince = () => {
  const navigate = useNavigate();
  const eventContext = useContext(EventContext);
  const { id } = useParams();
  const [submitFormLoading, setSubmitFormLoading] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getProvince();
  }, [id]);

  const getProvince = async () => {
    await useApi.get(
      `/general/province/${id}`,
      {},
      (res) => {
        eventContext.province = res.data.data;
        setLoading(false);
      },
      (err) => {
        setLoading(false);
        error('هنگام دریافت اطلاعات خطایی رخ داده است');
      },
    );
  };

  const onSubmitForm = async (values, setSubmitting) => {
    setSubmitFormLoading(true);

    await useApi.put(
      `/general/province/${id}`,
      values,
      (res) => {
        success(' استان با موفقیت ویرایش شد');
        navigate('/panel/province');
      },
      (err) => {
        setSubmitFormLoading(false);
        error('خطایی در ثبت اطلاعات پیش آمده است.');
      },
    );
  };

  return loading ? (
    <Loading />
  ) : (
    <Master>
      <Formik
        initialValues={{
          name: eventContext?.province?.name,
        }}
        onSubmit={(values, { setSubmitting }) => {
          onSubmitForm(values, setSubmitting);
        }}
        validationSchema={validationSchema}
      >
        {({
          values,
          errors,
          handleChange,
          handleSubmit,
          isSubmitting,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit}>
            <div className='row border rounded mt-3'>
              <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                <div className='form-group'>
                  <div className='d-flex flex-column mt-1 mx-2'>
                    <label>نام استان</label>
                    <input
                      name='name'
                      value={values.name}
                      onChange={handleChange}
                      type='text'
                      className='form-control'
                    />
                    <ErrorMessage error={errors.name} />
                  </div>
                </div>
              </div>

              <div className='col-12'>
                <div className='d-flex flex-row justify-content-end'>
                  <button className='btn btn-info btn-sm f-14'>
                    {submitFormLoading ? (
                      <div
                        className='spinner-border spinner-border-sm text-white mb-1'
                        role='status'
                      ></div>
                    ) : (
                      'ویرایش استان'
                    )}
                  </button>
                </div>
              </div>
            </div>
          </form>
        )}
      </Formik>
    </Master>
  );
};

export default EditProvince;
